import clsx from "clsx";
import type React from "react";

type Props = {
	children?: React.ReactNode;
	useExtraMargin?: boolean;
};

const StaffMembersTable: React.FunctionComponent<Props> = ({ children, useExtraMargin=false }) => {
	return (
		<table className={clsx("min-w-full border-separate border-spacing-y-2", useExtraMargin ? "mt-24": "mt-12")}>
			<thead>
				<tr>
					<th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">
						Name
					</th>
					<th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
						Karrierestufe / Anstellungsstatus
					</th>
					<th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
						Standort
					</th>
				</tr>
			</thead>
			<tbody className="divide-y divide-gray-200 bg-white">{children}</tbody>
		</table>
	);
};

export default StaffMembersTable;
